import * as Dialog from '@radix-ui/react-dialog'
import { cva } from 'class-variance-authority'
import { FC } from 'react'
import { createPortal } from 'react-dom'
import { Text } from '../../typography/text'
import './modal.css'
import { ModalProps } from './modal.types'



const ModalStyles = cva(``, {
  variants: {
    variant: {
      dialog:
        'fixed left-[50%] top-[50%] max-h-[80vh] w-[350px] translate-x-[-50%] translate-y-[-50%] rounded-2xl bg-white p-6 shadow-outer-md focus:outline-none lg:w-[450px] lg:p-8 z-[9999]',
      large:
        'fixed left-[50%] top-[50%] h-full w-[752px] no-scrollbar max-h-[80vh] overflow-scroll scroll  translate-x-[-50%] translate-y-[-50%] rounded-2xl bg-white shadow-outer-md focus:outline-none z-[9999]',
    },
    variantBody: {
      dialog: 'mb-8 max-h-[50vh] overflow-auto text-center lg:max-h-[55vh]',
      large: 'h-full',
    },
  },
})

export const Modal: FC<ModalProps> = ({
  isOpen,
  title,
  handleMaskClick,
  handleAfterClose,
  body,
  footerArray,
  showTitle = true,
  variant = 'dialog',
}) => (
  <>
    {/* if window is in browser environment */}
    {typeof window === 'object' &&
      createPortal(
        <Dialog.Root open={isOpen}>
          <Dialog.Portal>
            <Dialog.Overlay className=" fixed inset-0 bg-black/10" />
            <Dialog.Content
              onPointerDownOutside={handleMaskClick}
              onCloseAutoFocus={handleAfterClose}
              className={`modal-content ${ModalStyles({ variant })}`}
            >
              {showTitle && (
                <Dialog.Title className="mb-8 text-center">
                  <Text type="title" label={title} />
                </Dialog.Title>
              )}
              {body && (
                <div className={`${ModalStyles({ variantBody: variant })}`}>
                  {body}
                </div>
              )}
              {footerArray && (
                <div className="flex justify-center gap-4 border-0 outline-0">
                  {footerArray.map((footer, index) => (
                    <div key={index} className="m-0 border-0 outline-0">
                      {footer}
                    </div>
                  ))}
                </div>
              )}
            </Dialog.Content>
          </Dialog.Portal>
        </Dialog.Root>,
        document.body
      )}
  </>
)